<template>
    <div :class="{thumb:true, blocked:blocked}" @click="toggle(postData)">
      <div id="date">{{formatDate(postData.createdAt)}}</div>
      <img :src="postData.post.thumbnail_resources[3].src"/>
    </div>
</template>

<script>

  import moment from 'moment';
  import Backend from '@/Backend';

  export default {
    name: "instagramPost",
    props: ['postData', 'blocked'],
    data() {
      return {}
    },
    created() {
    },
    methods: {
      toggle(data) {
        // Backend.instance.blockPost(data._id, this.blocked);
        this.$emit('toggle', data);

      },
      formatDate(date) {
        return moment(date).format('HH:mm DD.MM.YYYY');
      }
    }
  }
</script>

<style scoped>
  .thumb {
    width: 15vw;
    height: 15vw;
    min-width: 100px;
    min-height: 100px;
    max-width: 200px;
    max-height: 200px;
    float: left;
    margin: 0.3rem;
    overflow: hidden;
    /*border: 1px solid dimgrey;*/
    cursor: pointer;
    border-radius: 0.3rem;
  }

  .thumb img {
    width: 100%;
    height: 100%;
  }

  .blocked {
    opacity: 0.3;
    filter: blur(2px);
  }

  #date {
    position: absolute;
    color: white;
    margin-top: 0.1rem;
    margin-left: 0.3rem;
    font-size: 0.8rem;
    padding: 0 0.5rem 0 0.5rem;
    background-color: rgba(0, 0, 0, 0.5);
  }



</style>



// WEBPACK FOOTER //
// src/components/instagram/InstagramPost.vue